import Hostapi from '@/core/utils/Hostapi'

export default {
    methods: {
        getSocketURL() {
            return Hostapi.getUrlApi() + '/sockjs'
        },
    }
}
